var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.253,
    height: 48.063,
    viewBox: "0 0 44.253 48.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": "+",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M32.325,2.437a131.117,131.117,0,0,0-4.277,33.43c-.041,3.792.205,7.571.511,11.351l-6.111.846A139.646,139.646,0,0,1,21.01,12.151,114.58,114.58,0,0,1,22.645,0l9.68,2.436",
    transform: "translate(-3.442)",
    fill: "#738bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M0,25.782c14.334-4.186,29.548-4.551,44.253-2.3L42.138,33.24c-.676-.168-1.547-.359-2.352-.517-12.462-2.39-25.5-2.852-37.931-.094L0,25.782",
    transform: "translate(0 -3.719)",
    fill: "#738bff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8937f7c471889b30669deaf7c8db5f89.svg";
export { ForwardRef as ReactComponent };